import { __extends } from "tslib";
import * as React from 'react';
import { ProductLineItemDataHook } from '../../ProductLineItem';
import * as _ from 'lodash';
import { classes, st } from './Options.st.css';
var Options = /** @class */ (function (_super) {
    __extends(Options, _super);
    function Options() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Options.prototype.render = function () {
        var _a = this.props, itemId = _a.itemId, options = _a.options, className = _a.className;
        var maxValueLength = 35;
        var getValue = function (value) {
            if ((value === null || value === void 0 ? void 0 : value.length) <= maxValueLength) {
                return value;
            }
            return _.truncate(value, { length: maxValueLength });
        };
        return (React.createElement("ul", { className: st(classes.root, className), "data-hook": ProductLineItemDataHook.Options }, options.map(function (option) {
            return (option.value.trim() &&
                (option.title ? (React.createElement("li", { key: "option-item-" + itemId + "-value-" + option.title },
                    option.title,
                    ": ",
                    getValue(option.value))) : (React.createElement("li", { key: "option-item-" + itemId + "-value-" + option.value }, getValue(option.value)))));
        })));
    };
    Options.displayName = 'ProductLineItem.Options';
    return Options;
}(React.PureComponent));
export { Options };
//# sourceMappingURL=Options.js.map